import { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../store/authStore.jsx';

export default function OAuthCallbackPage() {
  const [params]     = useSearchParams();
  const { login, reload } = useAuth();
  const navigate     = useNavigate();

  useEffect(() => {
    const token = params.get('token');
    if (!token) {
      navigate('/login?error=oauth');
      return;
    }
    localStorage.setItem('sv_token', token);
    reload().then(() => navigate('/dashboard'));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-950">
      <div className="w-8 h-8 border-2 border-brand-500 border-t-transparent rounded-full animate-spin" />
    </div>
  );
}
